export const fontList = [
  { id: 0, label: 'Roboto' },
  { id: 1, label: 'Open Sans' },
  { id: 2, label: 'Montserrat' },
  { id: 3, label: 'Poppins' },
  { id: 4, label: 'Nunito' },
  { id: 5, label: 'Source Sans Pro' },
  { id: 6, label: 'Oxygen' },
  { id: 7, label: 'Sora' },
  { id: 8, label: 'Hahmlet' },
  { id: 9, label: 'Andada Pro' },
  { id: 10, label: 'Epilogue' },
  { id: 11, label: 'JetBrains Mono' },
  { id: 12, label: 'Inter' },
  { id: 13, label: 'Encode Sans' },
  { id: 14, label: 'Manrope' },
  { id: 15, label: 'Lora' },
  { id: 16, label: 'Playfair Display' },
  { id: 17, label: 'Archivo' },
  { id: 18, label: 'Oswald' },
  { id: 19, label: 'Cormorant' },
];
